import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-profile-orders-raffle',
  templateUrl: './profile-orders-raffle.component.html',
  styleUrls: ['./profile-orders-raffle.component.scss']
})
export class ProfileOrdersRaffleComponent implements OnInit {

  @Input() employeeorder: [];

  orderedDate = new Date();

  constructor() { }

  ngOnInit() {

  }

}
